<!-- 落地页配置 -->
<template>
  <div>
    <el-form
      ref="landPageForm"
      :model="ldyParam"
      style="padding:20px"
      label-width="80px"
      :label-position="labelPosition"
      v-if=" activeName=='four'"
    >
      <!-- 操作栏 -->
      <div class="action-bar">
        模版：
        <el-input
          size="small"
          placeholder="请输入模版"
          clearable
          class="param-input"
          v-model="ldyParam.templet"
          @input="input"
        ></el-input>

        <el-divider></el-divider>按钮配置：
        <el-button type="primary" size="small" @click="addAction">新增</el-button>
      </div>
      <div class="form_item" style="display:flex" v-for="(item, i) in this.arrs" :key="i">
        <el-form-item label="按钮样式:" style="marginLeft: 20px;">
          <el-select v-model="item.style" size="small" placeholder="按钮样式" clearabl>
            <el-option value="switchSimple" label="简单"></el-option>
            <el-option value="switchStress" label="突出"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="按钮类型:" style="marginLeft: 20px;">
          <el-select v-model="item.type" size="small" placeholder="按钮类型" clearabl>
            <el-option value="iosEnterprise" label="ios企业包开关"></el-option>
            <el-option value="iosStore" label="ios商店包开关"></el-option>
            <el-option value="android" label="安卓开关"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="显示按钮:" style="marginLeft: 20px;">
          <el-checkbox v-model="item.enable"></el-checkbox>
        </el-form-item>

        <el-form-item style="marginLeft: -30px;">
          <el-button type="danger" icon="el-icon-delete" circle size="small" @click="deleteRow(i)"></el-button>
        </el-form-item>
      </div>
      <el-form-item class="myFooter" style="position: absolute;bottom: -35px;right: 20px;">
        <!-- <el-button size="small">取 消</el-button> -->
        <el-button
          type="primary"
          @click="submitForm('landPageForm')"
          :loading="flag"
          size="small"
        >保 存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import API from "@/api";
export default {
  props: ["querry", "activeName"],
  data() {
    return {
      labelPosition: " left",
      flag: false,
      arrs: [],
      id: "", //唯一码
      ldyParam: {
        templet: "",
        buttons: [
          {
            type: "", //开关类型
            style: "", //开关样式
            enable: false, //true:显示按钮
          },
        ],
      },
    };
  },
  created() {
    this.intLdy();
  },
  methods: {
    submitForm(landPageForm) {
      this.$refs[landPageForm].validate((valid) => {
        if (valid) {
          this.editLdy();
        } else {
          return false;
        }
      });
    },
    editLdy() {
      this.flag = true;
      this.ldyParam.buttons = this.arrs;
      let param = Object.assign({}, this.ldyParam, { id: this.id });
      API.updateLandPage(param)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑落地页配置成功！",
              type: "success",
            });
            this.$emit("editPage");
          } else {
            this.$message.error("编辑落地页配置失败！");
          }
          this.flag = false;
        })
        .catch(() => {
          this.flag = false;
        });
    },
    //落地页配置--新增
    addAction() {
      if (!this.arrs) this.arrs = [];
      this.arrs.push({
        style: "switchStress",
        type: "",
        enable: false,
      });
    },
    // 落地页配置--删除某行
    deleteRow(i) {
      this.arrs.splice(i, 1);
    },
    input() {
      this.$forceUpdate();
    },
    //初始化数据
    //     type: "", //开关类型
    // style: "", //开关样式
    // enable: false //true:显示按钮
    intLdy() {
      this.ldyParam = {
        templet: this.querry.ldyCfg.templet,
        buttons: this.querry.ldyCfg.buttons,
      };

      this.arrs = this.ldyParam.buttons;
      this.id = this.querry.id;
      if (
        this.labelPosition.buttons &&
        this.labelPosition.buttons.length != 0
      ) {
        this.labelPosition.buttons = {
          type: this.querry.ldyCfg.buttons.type,
          style: this.querry.ldyCfg.buttons.style,
          enable: this.querry.ldyCfg.buttons.enable,
        };
      }
    },
  },
};
</script>

<style lang='' scoped>
</style>